import React from 'react';
import { Calendar, MessageCircle, Globe } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface Feature {
  icon: LucideIcon;
  title: string;
  sub: string;
}

interface TrialPreviewProps {
  features?: Feature[];
}

const DEFAULT_FEATURES: Feature[] = [
  {
    icon: Calendar,
    title: 'Agenda inteligente',
    sub: 'Horários por barbeiro, encaixes na hora.',
  },
  {
    icon: MessageCircle,
    title: 'WhatsApp integrado',
    sub: 'Confirma e retorna automaticamente.',
  },
  // "Pagamento online" saiu (2026-07-07): o produto NAO oferece cobranca
  // do cliente final - Pix/boleto e como o TENANT paga a assinatura.
  // O 3o pilar real e a pagina publica de agendamento do tenant.
  {
    icon: Globe,
    title: 'Página de agendamento',
    sub: 'Seu link próprio - clientes marcam sozinhos, 24h.',
  },
];

/**
 * Lista vertical de 3 feature cards exibida no signup desktop. Mostra
 * os pilares do produto - 1 linha cada, com tile colorido + titulo +
 * subtitulo curto.
 *
 * Origem: templates/Login com Google/src/desktop-signup.jsx <TrialPreview>.
 * Icones do template (emoji) substituidos pelos `lucide-react` que ja
 * temos na biblioteca.
 */
export function TrialPreview({ features = DEFAULT_FEATURES }: TrialPreviewProps) {
  return (
    <ul className="auth-trial" aria-label="Recursos inclusos">
      {features.map((feature) => {
        const Icon = feature.icon;
        return (
          <li key={feature.title} className="auth-trial__card">
            <span className="auth-trial__icon" aria-hidden="true">
              <Icon strokeWidth={1.8} />
            </span>
            <div>
              <p className="auth-trial__title">{feature.title}</p>
              <p className="auth-trial__sub">{feature.sub}</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
